import { Form } from "antd"
import React from "react"

import { type TeamMembersFilterOptions } from "../../../../TeamManagementPage/redux/team-members.types.ts"
import { type SettingsCompanyFormData } from "../SettingsCompanyForm.tsx"
import { ResolvedSelect } from "../../../../../components/Select/ResolvedSelect.tsx"
import { TextInput } from "../../../../../components/Input/TextInput.tsx"
import { CompanyAlertThresholdsFormSection } from "./CompanyAlertThresholdsFormSection.tsx"
import { CompanyInvoiceDefaultsFormSection } from "./CompanyInvoiceDefaultsFormSection.tsx"

interface CompanyOperationalDefaultsFormSectionProps {
  options: TeamMembersFilterOptions | null
}

/**
 * Plain, independently-stored fields today — NOT the company-default/
 * branch-override pair the multi-branch PRD's CFG 02 describes (`Using
 * company default` / `Customized for this branch` / `Reset to company
 * default`). Neither `apps.user.services.permission_service`'s
 * `GccDefaultsView` nor anything else currently treats a branch's
 * `default_tax_pct` etc. as inheriting from a company-wide value — each
 * branch's `CompanyDetails` row holds its own, independently. Showing an
 * inheritance badge or a "reset to company default" control here would
 * be decorative only, so this section deliberately does not add one;
 * building real inheritance semantics for these fields is a separate,
 * larger piece of work than this layout pass.
 */
export function CompanyOperationalDefaultsFormSection({
  options
}: CompanyOperationalDefaultsFormSectionProps) {
  return (
    <>
      <Form.Item<SettingsCompanyFormData> label={"Lead Cost Method"} name="lead_cost_method">
        <ResolvedSelect
          options={options?.["lead_cost_method"]}
          placeholder="Enter lead cost method"
        />
      </Form.Item>

      <CompanyInvoiceDefaultsFormSection />

      <CompanyAlertThresholdsFormSection />

      <Form.Item<SettingsCompanyFormData>
        label={"Account for Receiving Money"}
        name="receiving_account"
      >
        <TextInput disableAutoCapitalize placeholder="Enter receiving account" />
      </Form.Item>
    </>
  )
}
